module.exports = __webpack_public_path__ + "static/media/paper23.92004713.jpg";